module.exports = __webpack_public_path__ + "images/sprites/ui/icon_input_radio_normal_2ce754f11af45041c0094956888fa64b.png";